import { Navigate, useParams } from "react-router";
import { BrandingEditor } from "@/branding/BrandingEditor";
import { DEFAULT_BRANDING_GROUP, groupForSlug } from "@/branding/groups";

/**
 * Org admin only. The tenant comes from the caller's own token on every API
 * call this makes (see `orgBrandingRouter`), so an org admin can only ever
 * write their own organization's overrides — never another org's, and never
 * the platform default.
 */
export function OrgBrandingPage() {
  const { orgSlug, group: groupSlug } = useParams();
  const group = groupForSlug(groupSlug);

/**
 * `:group` is user-typed, so an unknown segment must not render an empty
 * editor. It redirects to the first tab rather than 404ing — the person was
 * clearly heading for branding.
 */
  if (!group) {
    return <Navigate replace to={`/${orgSlug}/admin/settings/${DEFAULT_BRANDING_GROUP.slug}`} />;
  }

  return (
    <BrandingEditor activeGroup={group} basePath="/org/branding" mode="org" />
  );
}
